import React from 'react';

import { LinearProgress, Box } from '@gogame/components';

import { useImagesArray } from './useImagesArray';

const ScrubberFrames = ({
  frames,
  width = 200,
  height = 200,
  aspectRatio,
  placeholderUrl,
}) => {
  const [currentFrameIndex, setCurrentFrameIndex] = React.useState(0);
  const [containerRect, setContainerRect] = React.useState({});

  const imgRef = React.useRef(null);

  const imagesArray = useImagesArray({
    frames,
    placeholderUrl,
  });

  React.useEffect(() => {
    const frameSrc = frames?.[currentFrameIndex];
    if (imgRef.current !== null && frameSrc && containerRect.width) {
      try {
        imgRef.current.src = frameSrc;
        // const ctx = imgRef.current.getContext('2d');
        // ctx?.drawImage(img, 0, 0, containerRect.width, containerRect.height);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e, imagesArray, currentFrameIndex);
      }
    }
  }, [imagesArray, currentFrameIndex, containerRect]);

  const handleMouseMove = (e) => {
    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const step = rect.width / frames.length;

    const frameIndex = Math.max(Math.floor(x / step), 0);

    setCurrentFrameIndex(frameIndex);
  };

  const ref = React.useRef(null);
  React.useEffect(() => {
    setTimeout(() => {
      ref.current && setContainerRect(ref.current.getBoundingClientRect());
    });
  }, []);

  return (
    <Box
      sx={{
        color: 'grey.400',
        position: 'relative',
        lineHeight: 0,
        width: width,
        height: height,
        aspectRatio: aspectRatio,
      }}
      ref={ref}
      onMouseMove={handleMouseMove}
      data-cy={'scrubber'}
    >
      <img
        ref={imgRef}
        width={containerRect.width}
        height={containerRect.height}
        src={placeholderUrl}
        style={{
          position: 'absolute',
        }}
        alt={''}
      />

      <LinearProgress
        variant={'determinate'}
        color={'inherit'}
        value={((currentFrameIndex + 1) / frames.length) * 100}
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
        }}
      />
    </Box>
  );
};

export default ScrubberFrames;
